import { JetView } from 'webix-jet'; // Import JetView base class to define custom Webix views
import { devConfig } from 'config/config'; // Import development configuration object
import Filter from 'jet-views/customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory'; // Import filter component
import Table from 'jet-views/customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory'; // Import table component

export default class LoyaltyLevelChangeHistoryViewView extends JetView {
    config() {
        // Check if user has permission to access this module
        if (!devConfig.getPermAction('customersReportsPlayerRouletteReportMenu', 'Menu')) {
            webix.message({ type: "error", text: "No tienes permiso para acceder a este módulo" }); // Show error message
            const url = window.location.href; // Get current URL
            const match = url.match(/(\?user=\d+)/); // Extract user ID parameter
            if (match) {
                const newPath = "/top/customers" + match[0] + "/customers.reportscustomer"; // Build redirect path
                this.app.show(newPath); // Redirect user
            }
            return; // Stop configuration if no permission
        }

        const _ = this.app.getService('locale')._; // Get localization method
        const theme = this.app.config.theme; // Get current theme

        // Define main toolbar for pagination and export
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6', // Apply style classes
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown to choose number of rows per page
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Change event updates datatable page size
                            $$('datatable').getPager().config.size = this.getValue() * 1;
                            $$('datatable').refresh(); // Reload datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pagination control
                    id: 'pagerA',
                    template: '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default number of records per page
                },
                {
                    view: 'richselect', // Dropdown for export actions
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'),
                    options: [
                        { id: '1', value: 'Excel' }, // Excel option
                        { id: '2', value: 'PDF' }, // PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handle export logic when user selects option
                            var size = $$('datatable').getPager().config.size; // Get page size
                            var page = $$('datatable').getPage(); // Get current page index
                            var first = size * page; // Index of first record in page
                            var last = first + size - 1; // Index of last record in page

                            if (value == 1) {
                                // Excel export logic
                                var table = $$('datatable');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove column formatting for export
                                    }
                                }
                                webix.toExcel(table, {
                                    filter: function (obj) {
                                        // Export only current page rows
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', { hour12: true })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Sesiones', // Dynamic filename
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false, // Do not include footer
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export logic
                                    webix.toPDF($$('datatable'), {
                                        filter: function (obj) {
                                            // Export only current page rows
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', { hour12: true })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Sesiones',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset dropdown selection
                        },
                    },
                },
            ],
        };

        // Define main section that contains filter, table and toolbar
        const left = {
            height: screen.width < 500 ? 0 : 600, // Adjust height based on screen size
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply current theme color
                    id: 'toolbar-search',
                    elements: [
                        { view: 'label', label: _('Reporte de Sesiones') }, // Report title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Open popup with filters
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Insert Filter component
                Table, // Insert Table component
                toolbar, // Insert Toolbar
            ],
        };

        // Return the main form configuration
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scrollY: true, // Enable vertical scrolling
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Include left-side layout
                },
            ],
        };
    }

    // Initialize method executes after view rendering
    init(grid) {
        webix.ready(function () {
            // Wait until Webix components are ready
            if (screen.width < 500 || screen.height < 500) {
                // Behavior for small screens
                var childs = $$('toolbar').getChildViews(); // Get all toolbar children
                $$('toolbar').removeView(childs[2]); // Remove export dropdown
                $$('pagerA').define('group', 1); // Set grouping for pager
            }
            if (screen.width > 500 && screen.height > 500) {
                // Behavior for large screens
                $$('toolbar-search').hide(); // Hide search toolbar
            }
            $.fn.scrollBottom = function () {
                // jQuery function to compute distance to bottom
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}
